<template>
  <div class="container-detail">
    <!-- 主题信息 -->
    <div class="container-page-body">
      <div class="pages-list">
        <van-list
            v-model:loading="loading"
            :finished="finished"
            finished-text="没有更多了"
            offset="0"
            @load="getList"
        >
          <div class="pages-item"
               v-for="(item, index) in data.list"
               :key="index"
               @click="buttonSelect(item)">
            <div class="pages-item-border">
              <div class="pages-item-left">
                <div class="info">{{ item.userName }}<span
                    v-show="item.repairTypeName.length>0">-</span>{{ item.repairTypeName }}
                </div>
                <div class="tel">{{ item.phone }}</div>
              </div>
              <div v-if="item.key===selectId" class="pages-item-button active">取消选择</div>
              <div v-else class="pages-item-button">选择</div>
<!--              <div class="pages-item-phone"><img src="../../../assets/image/repair/repair/phone.png"></div>-->
            </div>
          </div>
        </van-list>
      </div>
    </div>

    <!-- 底部菜单，管理员 和 维修员 -->
    <div class="container-page-footer">
      <div class="footer-button-list">
        <div class="button button-confirm" @click="buttonConfirm">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
import {onMounted, ref} from "vue";
import {Toast, Skeleton, Step, Steps} from "vant";
import {useRouter} from "vue-router";
import {useStore} from "vuex";

export default {
  name: "applyDetail",
  components: {
    [Skeleton.name]: Skeleton,
    [Step.name]: Step,
    [Steps.name]: Steps,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    let loading = ref(false); // 接口调用使用
    let finished = ref(false); // true时接口调用完成，之后上拉不会调用接口
    let refreshing = ref(false); // 刷新页面使用
    let lock = ref(true); // 确定按钮锁
    let id = ref('');
    let selectId = ref(''); // 单选，
    let selectInfo = ref({});
    let data = ref( {
      total: 0,
      list: [],
    });
    let queryParams = ref({
      pageNo: 1,
      pageSize: 10,
    });

    // 报修记录-列表接口
    const getRecordUserSelectApi = (params) => store.dispatch("repair/getRecordUserSelect", params);

    const getList = async () => {
      loading.value = true;
      let r = await getRecordUserSelectApi({
        userType: 'repair',
      });

      if (refreshing.value) {
        data.value.list = [];
        refreshing.value = false;
      }

      if (r.message === "success") {
        data.value.total = r.data.total;
        r.data.list.map((item) => {
          if(item.innerType === 'inner'){
            item.key = item.innerType + '||' + item.userId;
          } else {
            item.key = item.innerType + '||' + item.userName + '||' + item.phone;
          }

        });
        data.value.list = data.value.list.concat(r.data.list);
      } else {
        Toast.fail(r.message);
      }

      loading.value = false;
      finished.value = true;
      // if (!r.data || r.data.list.length < queryParams.value.pageSize) {
      //   finished.value = true;
      // }
    };

    const buttonSelect = (item) => {
      console.log('选择', item);
      if (selectId.value !== '' && selectId.value === item.key) {
        selectId.value = ''; // 点击自身选项，则自动取消
        selectInfo.value = {};
      } else {
        selectId.value = item.key;
        selectInfo.value = item;
      }
    };

    const postRepairDistributeApi = (params) => store.dispatch("repair/postRepairDistribute", params);
    const buttonConfirm = async () => {
      console.log('确定', selectId.value);
      if (loading.value) {
        Toast.fail('页面加载中');
        return;
      }
      if (selectId.value === '') {
        Toast.fail('请选择维修人');
      } else {
        console.log('请求接口', selectId.value, selectInfo.value);
        let params = {
          phone: selectInfo.value.phone,
          repairId: id.value,
          userId: selectInfo.value.userId,
          userIndex: selectInfo.value.userIndex || '',
          userName: selectInfo.value.userName,
        };
        let r = await postRepairDistributeApi(params);
        if (r && r.message === "success") {
          Toast.success('添加成功');
          router.push(`/repair/report/serviceDetail?id=` + id.value);
        }
        lock.value = true;
      }
    };

    onMounted(() => {
      id.value = router.currentRoute.value.query.id;
    });

    return {
      loading,
      finished,
      refreshing,
      lock,
      id,
      selectId,
      selectInfo,
      data,
      queryParams,

      getList,
      buttonSelect,
      buttonConfirm,
    };
  },
};
</script>
<style lang="less" scoped>
.container-page-header {
  height: 100%;
  font-size: 12px;
  margin-bottom: 48px;

  .top-tabs {
    position: fixed;
    top: 48px;
    left: 0;
    right: 0;
    z-index: 900;
  }

  .page-top-line {
    position: fixed;
    top: 48px;
    left: 0;
    right: 0;
    z-index: 900;
    height: 3px;
    background-color: #ffffff;
    border-bottom: 1px solid #F2F4FA;
  }

  .top-bar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 900;
    height: 48px;
    color: #fff;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 12px;
    box-sizing: border-box;

    .back {
      width: 36px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: flex-start;

      .left_img {
        width: 24px;
        height: 24px;
      }
    }

    .page_title {
      font-weight: 500;
      color: #343434;
      line-height: 20px;
      font-size: 18px;
    }
  }
}

.container-page-body {
  background-color: #F2F4FA;
  padding-top: 10px;
  padding-bottom: 80px;

  .pages-list {
    min-height: 630px;

    .pages-item:last-child {
      border-bottom: 0;
    }

    .pages-item {
      background-color: #ffffff;
      padding: 0 10px;

      .pages-item-border {
        padding: 14px 0;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: #ffffff;
        border-bottom: 1px solid #E5E5E5;

        .pages-item-left {
          width: 60%;

          .info {
            color: #333333;
            font-size: 15px;
            font-weight: bold;
            margin-bottom: 5px;
          }

          .tel {
            color: #999999;
            font-size: 13px;
          }
        }

        .pages-item-button {
          width: 86px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          background-color: #4174FD;
          border: 1px solid #4174FD;
          color: #ffffff;
          border-radius: 32px;
          font-size: 15px;
        }

        .active {
          background-color: #ffffff;
          color: #4174FD;
        }

        .pages-item-phone {
          img {
            width: 28px;
            height: 28px;
          }
        }
      }
    }
  }
}

.container-page-footer {
  position: fixed;
  width: 100%;
  height: 70px;
  bottom: 0;
  background-color: #ffffff;
  border: 1px solid #F2F4FA;
  z-index: 99;

  .footer-button-list {
    padding: 10px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .button {
      border: 1px solid #4275FD;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-radius: 30px;
      font-size: 15px;
    }

    .button-confirm {
      color: #ffffff;
      background-color: #4275FD;
    }
  }
}
</style>
